import { clsx } from "clsx";
import { SVGIconProps } from "../interface";
const iconSize: Record<string, string> = {
  8: "h-2",
  12: "h-3",
  16: "h-4",
  24: "h-6",
  32: "h-8",
  40: "h-10",
  48: "h-12",
  56: "h-14",
  80: "h-20",
  124: "h-30",
};
const SvgCar = ({ title, titleId, size = 16, className }: SVGIconProps) => {
  const sizeClass = iconSize[size];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 25"
      width={size}
      height={size}
      className={clsx(sizeClass, className)}
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path d="M23.25 11.688c0-1.577-1.231-2.813-2.7-2.813H4.45c-1.469 0-2.7 1.236-2.7 2.813v6.828c0 .428.33.734.688.734h2.587c.516 0 .975-.44.975-1.031V17.03a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 .75.75v1.188c0 .591.46 1.03.975 1.031h2.587c.357 0 .688-.306.688-.734zm-15.062.437a.75.75 0 0 1 0 1.5H5.313a.75.75 0 0 1 0-1.5zm11.5 0a.75.75 0 0 1 0 1.5h-2.875a.75.75 0 0 1 0-1.5zM7.914 1.75c-.909 0-1.73.608-2.017 1.521l-.05.187-.001.001-.886 3.916h15.11l-.784-3.865c-.212-1.042-1.092-1.76-2.08-1.76zM24.75 18.516c0 1.21-.957 2.234-2.187 2.234h-2.588c-1.39 0-2.475-1.157-2.475-2.531v-.438h-10v.438c0 1.374-1.086 2.53-2.475 2.531H2.438c-1.23 0-2.188-1.024-2.188-2.234v-6.828a4.35 4.35 0 0 1 1.793-3.536L.726 7.636l-.07-.032a.75.75 0 0 1 .545-1.39l.073.025 2.207.866.902-3.977.083-.308C4.943 1.312 6.319.25 7.914.25h9.292c1.734 0 3.203 1.253 3.55 2.96v.002l.787 3.887 2.182-.86a.751.751 0 0 1 .55 1.396l-1.318.518a4.35 4.35 0 0 1 1.793 3.534z" />
    </svg>
  );
};
export default SvgCar;
